/* eslint-disable radix */
import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import Footer from '~/components/Footer';
import Menu from '~/components/Menu';
import { Container } from '~/styles/pagesStyle';
import { handleSubmit } from '../UserServices';
import CadastroCard from './CadastroCard';

const initialForm = {};

function UserCadastro() {
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [togglePassword, setTogglePassword] = useState(false);
  const [form, setForm] = useState(initialForm);
  const usuarioLogado = sessionStorage.getItem('@auth/userName');
  const acessoRestrito = true;
  const excluido = false;
  const date = new Date().toISOString();

  async function handleSignupUser(event) {
    if (!form.idPessoaEmpresa) {
      toast.error('Empresa é obrigatório');
      return;
    }
    if (!form.user) {
      toast.error('Usuário é obrigatório');
      return;
    }
    if (!form.password) {
      toast.error('Senha é obrigatório');
      return;
    }
    const usuario = {
      id: 0,
      idPessoaEmpresa: form.idPessoaEmpresa,
      idPessoa: form.idPessoaEmpresa,
      login: form.user,
      senha: form.password,
      dataExpiracaoSenha: date,
      acessoRestrito,
      email: form.email || null,
      dataInclusao: date,
      usuario: usuarioLogado,
      excluido,
    };
    event.preventDefault();
    setLoading(true);
    await handleSubmit(event, usuario, setLoading);
    history.push('/user/list');
  }

  return (
    <Container>
      <Footer />
      <Menu />
      <CadastroCard
        setForm={setForm}
        form={form}
        handleSignupUser={handleSignupUser}
        loading={loading}
        setLoading={setLoading}
        setTogglePassword={setTogglePassword}
        togglePassword={togglePassword}
      />
    </Container>
  );
}

export default UserCadastro;
